@use '../../../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../../../styles/Constants.scss' as Constants;
@use "sass:color";

.BillableWorkListItem {
	$borderColor: color.adjust(Colors.$col-greyConnection, $lightness: 5%);
	

	display: flex;
	flex: 1;
	align-items: flex-start;
	flex-direction: row;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;
	border-bottom: solid 1px $borderColor;

	&:first-child {
		border-top: solid 1px $borderColor;
	}

	.content {
		$expanderSize: Constants.$val-icon24;
		$expanderSpacing: Constants.$val-spacing-xs;
		$expanderWidth: $expanderSize + $expanderSpacing;

		flex: 1;
		padding-left: $expanderWidth;

		.titleContainer {
			margin-left: -$expanderWidth;
			display: flex;
			flex-direction: row;
			align-items: center;
			cursor: pointer;
			transform: color 0.1s;

			&:hover {
				color: Colors.$col-orange;
			}
		}

		.expander {
			font-size: $expanderSize;
			margin-right: $expanderSpacing;
		}

		.workName {
			text-transform: uppercase;
			font-weight: bold;
			font-size: Constants.$val-fontSizeRegular;
			line-height: 24px; // aligns with the expander icon
		}
	}

	.actions {
		flex-direction: row;
		align-items: center;
		gap: Constants.$val-spacing-s;
		display: flex;

		.action {
			color: Colors.$col-design-grey15;
			font-size: Constants.$val-fontSizeXBig;
			cursor: pointer;
			transform: color 0.1s;

			&.delete:hover {
				color: Colors.$col-red;
			}

			&.edit:hover {
				color: Colors.$col-blue;
			}
		}
	}
}
